import React from 'react';
import { Box, Flex, Label } from '../../pdf-design-system';

export default function BarcelonaLogisticsPanel({ children, height, ...rest }) {
  return (
    <Box style={{ height }} {...rest}>
      {children}
    </Box>
  );
}

BarcelonaLogisticsPanel.Title = function ({ children }) {
  return (
    <Label
      variant="larger"
      style={{
        fontWeight: 600,
        borderTop: '2px solid black',
        borderBottom: '2px solid black',
        paddingTop: 4,
        paddingLeft: 5,
      }}
    >
      {children}
    </Label>
  );
};

BarcelonaLogisticsPanel.Body = function ({ children }) {
  // flexgrow: 1 ensures that content is vertically centered
  return <Flex style={{ alignItems: 'center', flexGrow: 1 }}>{children}</Flex>;
};

BarcelonaLogisticsPanel.LeftBody = function ({ children }) {
  return (
    <Flex
      style={{
        width: 218,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children}
    </Flex>
  );
};
BarcelonaLogisticsPanel.RightBody = function ({ children }) {
  return <Box>{children}</Box>;
};
